const PARAMS = ["code", "state", "error", "error_description"];

export function parseOAuthReturn(search) {
    const p = new URLSearchParams(search || "");
    return {
        code: p.get("code") || "",
        state: p.get("state") || "",
        error: p.get("error") || "",
        errorDescription: p.get("error_description") || "",
    };
}

export function cleanOAuthSearch(search) {
    const p = new URLSearchParams(search || "");
    PARAMS.forEach((k) => p.delete(k));
    const q = p.toString();
    return q ? `?${q}` : "";
}

// El code y el state de un solo uso no pueden quedarse en la barra, el historial
// ni el Referer: se leen y se borran en el mismo paso.
export function takeOAuthReturn() {
    const out = parseOAuthReturn(window.location.search);
    try {
        window.history.replaceState(
            window.history.state,
            "",
            window.location.pathname + cleanOAuthSearch(window.location.search) + window.location.hash,
        );
    } catch (_e) {}
    return out;
}

export function oauthErrorMessage(ret, label) {
    if (ret.error === "access_denied") return `Has cancelado la autorización en ${label}.`;
    return ret.errorDescription || `${label} no ha completado la autorización (${ret.error}).`;
}

// Mismo prefijo que APP_STATE_PREFIX en routes/connections.py.
export const APP_STATE_PREFIX = "app.";
export const APP_SCHEME = "es.qcap.app";

export function appReturnUrl(provider, ret) {
    const p = new URLSearchParams();
    PARAMS.forEach((k) => {
        const v = ret[k === "error_description" ? "errorDescription" : k];
        if (v) p.set(k, v);
    });
    return `${APP_SCHEME}://app/connections/${provider}/callback?${p.toString()}`;
}

function renderBounce(url) {
    const root = document.getElementById("root");
    if (!root) return;
    const wrap = document.createElement("div");
    wrap.className = "min-h-screen flex items-center justify-center bg-stone px-4";
    const card = document.createElement("div");
    card.className = "max-w-sm w-full bg-bone border border-soft_border rounded-xl p-6 text-center space-y-4";
    const title = document.createElement("p");
    title.className = "font-display text-2xl text-graphite";
    title.textContent = "Vuelve a QCapital";
    const text = document.createElement("p");
    text.className = "text-sm text-soft_muted";
    text.textContent = "Ya puedes volver a la app para terminar de conectar tu cuenta.";
    const link = document.createElement("a");
    link.className = "inline-block bg-petrol text-bone rounded-md px-4 py-2 text-sm font-medium";
    link.href = url;
    link.textContent = "Volver a QCapital";
    link.setAttribute("data-testid", "oauth-bounce-link");
    card.append(title, text, link);
    wrap.append(card);
    root.replaceChildren(wrap);
}

// La app abre la autorizacion en el navegador del sistema y la entidad vuelve a la web
// (la unica redirect_uri registrada). Si el state es de la app, esta pagina no monta
// la web: devuelve code y state a la app por su esquema, que los canjea con su sesion.
// Universal links / App Links no sirven aqui: iOS no los abre tras el 302 de la entidad.
export function bounceAppOAuthReturn(native, navigateTo = (u) => window.location.assign(u)) {
    if (native) return false;
    try {
        const m = RUTA.exec(window.location.pathname);
        if (!m) return false;
        const ret = parseOAuthReturn(window.location.search);
        if (!ret.state.startsWith(APP_STATE_PREFIX)) return false;
        takeOAuthReturn();
        const url = appReturnUrl(m[1].toLowerCase(), ret);
        renderBounce(url);
        // El boton queda por si el navegador no deja saltar a la app sin un toque.
        navigateTo(url);
        return true;
    } catch (_e) {
        return false;
    }
}

const CLAVE = "qc_oauth_return";
const VIGENCIA_MS = 10 * 60 * 1000;
const RUTA = /^\/app\/connections\/([a-z0-9_-]+)\/callback\/?$/i;

// Se llama antes de montar la app (index.js): gtag lee document.location en el primer
// page_view, asi que el code y el state tienen que salir de la barra antes. Se aparcan
// en sessionStorage para sobrevivir a una redireccion por sesion caducada.
export function parkOAuthReturn(now = Date.now()) {
    try {
        const m = RUTA.exec(window.location.pathname);
        if (!m) return false;
        const ret = takeOAuthReturn();
        if (!ret.code && !ret.state && !ret.error) return false;
        sessionStorage.setItem(CLAVE, JSON.stringify({ ...ret, provider: m[1].toLowerCase(), ts: now }));
        return true;
    } catch (_e) {
        return false;
    }
}

export function consumeParkedOAuthReturn(provider, now = Date.now()) {
    try {
        const raw = sessionStorage.getItem(CLAVE);
        if (!raw) return null;
        const v = JSON.parse(raw);
        if (v.provider !== String(provider).toLowerCase()) return null;
        sessionStorage.removeItem(CLAVE);
        if (now - v.ts > VIGENCIA_MS) return null;
        return { code: v.code, state: v.state, error: v.error, errorDescription: v.errorDescription };
    } catch (_e) {
        return null;
    }
}
